/**
 * Styled Components - Created by cazarez on 14/02/18.
 */
import Icon from 'antd/lib/icon'
import styled from 'styled-components'

export const Container = styled.div`
  padding: 16px 34px 44px 32px;
  background-color: #fff;
`

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 22px;
  justify-content: center;
  position: relative;
`

export const Text = styled.div`
  color: #5f6062;
  line-height: 23px;
`

export const CloseImg = styled(Icon)`
  background: #717171;
  border-radius: 25px;
  padding: 7px;
  max-width: 37px;
  margin-bottom: -16px;
  height: fit-content;
  color: white;
  box-shadow: 0px 1px 3px 0px #7e7e7e;
  position: absolute;
  right: 32px;
  &:hover {
    cursor: pointer;
  }
`

export const Results = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  @media (max-width: 480px) {
    flex-flow: column;
    justify-content: center;
    align-items: center;
  }
`

export const EmptySearch = styled.div`
  color: #5f6062;
  line-height: 23px;
`
export const ResultDiv = styled.div`
  margin-right: 16px;
  width: 224px;
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/SearchResults/styledComponents.tsx